import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  FaUser,
  FaBoxOpen,
  FaLock,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";

import { useAuthStore } from "../store/authStore";

export default function ProfileSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const clearAuth = useAuthStore((state) => state.clearAuth);

  // -------------------------
  // LOGOUT
  // -------------------------
  const handleLogout = () => {
    clearAuth();
    localStorage.removeItem("legacy-auth");

    window.location.href = "/";
  };

  // -------------------------
  // ACTIVE MENU
  // -------------------------
  const isActive = (path) => {
    return location.pathname === path;
  };

  const menuClass = (path) =>
    `w-full flex items-center gap-4 px-4 py-3 rounded-lg transition text-left ${
      isActive(path)
        ? "bg-[#FFF3E5] text-[#E87932] font-medium"
        : "text-gray-700 hover:bg-[#FFF8EC] hover:text-[#E87932]"
    }`;

  return (
    <aside className="bg-white border border-gray-200 rounded-xl shadow-sm p-3 h-fit">
      {/* My Profile */}
      <button
        type="button"
        onClick={() => navigate("/profile")}
        className={menuClass("/profile")}
      >
        <FaUser className="text-lg" />
        <span>My Profile</span>
      </button>

      {/* My Orders */}
      <button
        type="button"
        onClick={() => navigate("/orders")}
        className={menuClass("/orders")}
      >
        <FaBoxOpen className="text-lg" />
        <span>My Orders</span>
      </button>

      {/* All Order List - Admin Only */}
      {user?.id === "6a86fc0273e1ca02be82c099" && (
        <>
          <button
            type="button"
            onClick={() => navigate("/all-orders")}
            className={menuClass("/all-orders")}
          >
            <FaBoxOpen className="text-lg" />
            <span>All Orders</span>
          </button>

          <button
            type="button"
            onClick={() => navigate("/all-products")}
            className={menuClass("/all-products")}
          >
            <FaBars className="text-lg" />
            <span>Products</span>
          </button>
        </>
      )}

      {/* Change Password */}
      <button
        type="button"
        onClick={() => navigate("/change-password")}
        className={menuClass("/change-password")}
      >
        <FaLock className="text-lg" />
        <span>Change Password</span>
      </button>

      {/* Divider */}
      <div className="border-t border-gray-200 my-3" />

      {/* Logout */}
      <button
        type="button"
        onClick={handleLogout}
        className="w-full flex items-center gap-4 px-4 py-3 rounded-lg text-red-500 hover:bg-red-50 transition text-left"
      >
        <FaSignOutAlt className="text-lg" />
        <span>Logout</span>
      </button>
    </aside>
  );
}
